module.exports = __webpack_public_path__ + "static/case_thera-dfb949040ad40c852d1a1a046d2594de.jpg";